import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deletePromotion } from './api';

const LIST_KEY = 'marketing-promotions';

interface Promotion extends ListRow {
  id: number;
  title?: string;
  summary?: string;
  create_time?: number;
  update_time?: number;
}

const config: ListPageConfig<Promotion> = {
  queryKey: LIST_KEY,
  title: 'Наши акции',
  errorText: 'Ошибка загрузки акций',
  fetchList: postListFetcher('/promotion/list/'),
  rows: ['promotions'],
  columns: [
    { header: 'id', render: (promotion) => promotion.id },
    { header: 'Заголовок', render: (promotion) => promotion.title },
    { header: 'Описание', render: (promotion) => promotion.summary },
    { header: 'Время создания', render: (promotion) => formatUnixDateTime(promotion.create_time) },
    { header: 'Время обновления', render: (promotion) => formatUnixDateTime(promotion.update_time) },
    {
      header: 'Удалить',
      render: (promotion) => (
        <DeleteButton listKey={LIST_KEY} remove={() => deletePromotion(promotion.id)} />
      ),
    },
  ],
};

export const PromotionsPage = () => <GenericListPage config={config} />;
